import { render, staticRenderFns } from "./LoginUp.vue?vue&type=template&id=6586bc42&scoped=true&"
import script from "./LoginUp.vue?vue&type=script&lang=js&"
export * from "./LoginUp.vue?vue&type=script&lang=js&"
import style0 from "./LoginUp.vue?vue&type=style&index=0&id=6586bc42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586bc42",
  null
  
)

export default component.exports